export default __webpack_public_path__ + "static/6_Screenshot-a2506d1eedf69e7c7a91fe29a8a386a2.png";